module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(!_vm.isLoading && _vm.data.status.locked) ? _c('div', {
    attrs: {
      "id": "lessonLockScreen"
    }
  }, [_c('h1', {
    staticClass: "largeTitle blueTitle"
  }, [_vm._v("We're sorry, this content is not available to you yet")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "value": "lock"
    }
  }), _vm._v(" "), _c('p', [_vm._v("This lesson is not available to you for another " + _vm._s(_vm.data.status.remaining) + " day(s)")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btnRedirect",
    attrs: {
      "label": "Go to Dashboard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDashboard.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.data.status.locked === false) ? _c('div', [(!_vm.data.taken.start_questions) ? _c('lesson-rating-panel', {
    staticClass: "marginBottom",
    attrs: {
      "mode": "start",
      "course": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.data.title)
    }
  })])]), _vm._v(" "), _c('lesson-personalised-panel', {
    attrs: {
      "course": _vm.data,
      "courseId": _vm.data.course_id
    },
    on: {
      "isMainVideoVisible": _vm.toggleMainVideo
    }
  }), _vm._v(" "), (_vm.isMainVideoVisible) ? _c('mu-card', [_c('iframe-video-player', {
    attrs: {
      "src": _vm.data.videos.vimeo.web
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-text', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.data.content))
    }
  }), _vm._v(" "), (_vm.data.audio_url) ? _c('audio-player', {
    staticClass: "bottom",
    attrs: {
      "url": _vm.data.audio_url
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "icon": _vm.isTranscriptOpen ? 'expand_less' : 'expand_more',
      "label": _vm.isTranscriptOpen ? _vm.$t('message.lessonHideTranscript') : _vm.$t('message.lessonViewTranscript'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleTranscript.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isTranscriptOpen) ? _c('mu-card', {
    staticClass: "marginBottom removeBrs"
  }, [_c('mu-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.data.transcript))
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-raised-button', {
    nativeOn: {
      "click": function($event) {
        _vm.isTranscriptOpen = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.closeText')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom",
    attrs: {
      "id": "action_points"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": _vm.$t('message.lessonActionPoints'),
      "subTitle": _vm.$t('message.lessonActionPointsSubTitle')
    }
  }), _vm._v(" "), _c('iframe-video-player', {
    attrs: {
      "src": _vm.data.videos.vimeo_ap.web
    }
  }), _vm._v(" "), _c('mu-card-text', {
    attrs: {
      "id": "actionList"
    }
  }, _vm._l((_vm.data.action_points), function(action, index) {
    return _c('div', {
      key: 'action-' + index,
      staticClass: "action"
    }, [_c('div', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(action.title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(action.action))
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('lesson-rating-panel', {
    staticClass: "bottom",
    attrs: {
      "mode": "end",
      "course": _vm.data
    }
  }), _vm._v(" "), (_vm.data.quiz.length > 0) ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('lesson-quiz-panel', {
    attrs: {
      "quiz": _vm.data.quiz,
      "course_id": _vm.data.course_id,
      "quiz_id": _vm.data.quiz_id
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('lesson-downloads-panel', {
    staticClass: "bottom",
    attrs: {
      "downloads": _vm.data.downloads
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('lesson-questions-panel', {
    attrs: {
      "course-id": _vm.data.course_id
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fbbbad7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Lesson/Lesson.vue
// module id = 3193
// module chunks = 1